/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query CustomerAccountMarginReportQuery($customerAccountId: ID, $customerAccountIds: [ID!], $endDate: DateTime!, $startDate: DateTime!) {
  CustomerAccountMarginReport(customerAccountId: $customerAccountId, customerAccountIds: $customerAccountIds, endDate: $endDate, startDate: $startDate) {
    id,
    status,
    message,
    _reportData,
    totalsDetail {
      totalCost,
      totalMargin,
      totalRevenue
    }
  }
}
`
